<template>
  <transition name="pop">
    <div v-show="visible"
    :style="customCss"
      :class="{
        'toast-modal': showModal,
        'toast-bottom': message === '点歌成功' || position === 'bottom'
      }"
    >
      <img v-if="toastImg" class="toast-img" :style="{width: `${imgWidth}px`}" :src="toastImg" alt="">
      <!-- 图+文 样式完全自定义的toast -->
      <div v-else-if="toastTxt" class="wrap" :class="costomClass">
       <img v-if="iconPath" :src="iconPath" class="icon"/>
       <p v-html="toastTxt"></p>
      </div>
      <div v-else class="toast"
        :class="costomClass"
        :style="toastStyle"
        @click="handleClick">
        <svg-icon :iconClass='Icon'
              :className='toastSvg'
              v-show="iconName!==''" />
        <p :class="messageClass" v-html="message"></p>
        <p class='tip' v-show="tip">{{tip}}</p>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  name: 'toast',
  props: {
    message: String,
    tip: String,
    className: { // 样式
      type: String,
      default: '',
    },
    iconName: { // 图标信息
      type: String,
      default: '',
    },
    position: { // 位置
      type: String,
      default: '',
    },
    toastSvg: {
      type: String,
      default: 'toast-svg',
    },
    type: {
      type: String,
      default: '',
    },
    callback: Function,
    toastImg: {
      type: String,
      default: '',
    },
    imgWidth: [Number, String],
    toastStyle: String,
    showModal: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      visible: false,
      iconPath: '',
      toastCss: {},
      toastTxt: '',
    };
  },
  computed: {
    customCss() {
        return {
            '--toast-height': this.toastCss.toastHeight || '13.3vw',
            '--toast-padding-left': this.toastCss.paddingLeft || '11.86vw',
            '--toast-padding-right': this.toastCss.paddingRight || '11.86vw',
            '--icon-height': this.toastCss.iconHeight || '4.8vw',
            '--icon-margin-right': this.toastCss.iconMarginRight || '2.1vw',
        }
    },
    costomClass() {
      let classes = '';
      switch (this.position) {
        case 'top':
          classes += 'placeTop ';
          break;
        case 'center':
          classes += 'placeMiddle ';
          break;
        default:
          classes += 'placeBottom ';
      }
      switch (this.type) {
        case 'simple':
          classes += ' simple';
          break;
        case 'simple_null':
          classes += ' simple simple_null';
          break;
        default:
          break;
      }
      classes += this.className;
      return classes;
    },
    Icon() {
      if (this.iconName) {
        return this.iconName;
      }
      return '';
    },
    messageClass() {
      if (this.message) {
        if (this.message.includes('<br/>')) {
          return 'long';
        }
        if (this.message.length > 15) {
          return 'longer';
        }
        if (this.message.length > 10) {
          return 'long';
        }
      }
      return '';
    },
  },
  methods: {
    handleClick() {
      if (this.callback) {
        this.callback();
      }
      if (this.type !== '弹窗') {
        this.close();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.wrap {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 20px;
    height: var(--toast-height);
    padding: 0 var(--toast-padding-right) 0 var(--toast-padding-left);
    background: rgba(0, 0, 0, 0.75);
    position: fixed;
    color: #fff5e7;
    font-size: 30px;
    z-index: $z_index_toast;
    transition: opacity 0.5s linear;
    line-height: 1;
    .icon {
        width: auto;
        height: var(--icon-height);
        margin-right: var(--icon-margin-right);
        vertical-align: bottom;
    }
}
.toast-modal{
    width: 100%;
    height: 100vh;
    background: rgba(0,0,0,0.5);
    position: fixed;
    top:0;
    left:0;
    z-index: $z_index_three;
}
.toast {
  padding: 30px 38px;
  border-radius: 15px;
  font-size: 30px;
  box-sizing: content-box;
  position: fixed;
  background: rgba(0, 0, 0, 0.85);
  color: #fff5e7;
  text-align: justify;
  z-index: $z_index_toast;
  transition: opacity 0.5s linear;
  .toast-svg {
    width: 40px;
    height: 40px;
    vertical-align: middle;
    margin-right: 10px;
  }
  p {
    line-height: 42px;
    text-align: center;
  }
  .tip {
    color: #e86f2b;
    font-size: 26px;
  }
  .long {
    width: 338px;
  }
  .longer{
    width: 538px;
  }
}
.fit-content {
  width: max-content;
  p:not(.tip) {
    width: max-content;
    word-break: keep-all
  }
}
.toast-img{
    width: 426px;
    position: fixed;
    left:50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: $z_index_toast;
    transition: opacity 0.5s linear;
}
.toast-bottom {
  .placeMiddle, .toast-img {
    top: unset;
    bottom: 100px;
  }
}
.placeTop {
  top: 50px;
  left: 50%;
  transform: translate(-50%, 0);
}
.placeBottom {
  left: 50%;
  top: 80%;
  transform: translate(-50%, -50%);
}
.placeMiddle {
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.widthAuto {
  width: auto;
  .long {
    width: auto;
    word-break: keep-all;
  }
}
.pop-enter,
.pop-leave-active {
  opacity: 0;
}
.simple {
  background: #62c989;
  width: 330px;
  height: 90px;
  line-height: 90px;
  padding: 0 !important;
  font-size: 36px;
  font-family: "pingfangsc-medium";
}
.simple_null {
  width: 422px;
  height: 73px;
  line-height: 73px;
  font-size: 30px;
}
.video-toast {
  width: auto;
  background: #000000b3;
  border-radius: 45px;
  padding: 20px 45px;
  top: calc((100vh - 110px) / 2 + 45px);
  p {
    width: auto!important;
    word-break: keep-all;
  }
}
 .center-border{
   width: 270px;
   background: #000000bf;
   border-radius: 61px;
 }
</style>
